import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import cseAimlFacultyData from "./facultyData/cseAimlFacultyData";

const facultyOrder = [
  "f-ravindra-patil",
  "f-ekata-shanbhag",
  "f-bheerappa-sasanoor",
  "f-narasimha-dixit",
  "f-amarnath-swami",
  "f-kanchan-khokale",
  "f-jyoti-chitti",
  "f-laxmi-g-hattiholi",
];

const getOrderedFacultyMembers = (members = []) => [
  ...facultyOrder
    .map((id) => members.find((faculty) => faculty.id === id))
    .filter(Boolean),
  ...members.filter((faculty) => !facultyOrder.includes(faculty.id)),
];

const facultyData = {
  ...cseAimlFacultyData,
  members: getOrderedFacultyMembers(cseAimlFacultyData.members),
};

export const programme = {
  id: "cse-aiml",
  name: "Computer Science & Engineering (AI & ML)",
  short: "CSE (AI & ML)",
  programmeType: "ug",
  // programmeLabel: "B.E.",
  duration: "4 Years (8 Semesters)",
  intake: 60,
  // studentsEnrolled: 240,
  // facultyStrength: 8,
  phdFaculty: 1,
  established: 2022,
  description: "The Department of Computer Science and Engineering (Artificial Intelligence & Machine Learning) was established in 2022 to provide quality education in the rapidly growing fields of AI and ML. The department offers a B.E. program that equips students with strong foundations in programming, data science, machine learning, artificial intelligence, and intelligent systems.",
  image: "/HomePage/dept/aiml.jpeg",
  hodId: "f-poornima-raikar",
  facultyData,
  labs: ["AI Lab", "Machine Learning Lab", "Data Structure Lab", "Python Lab", "C Programming Lab"],
  research: "Artificial Intelligence · Machine Learning · Data Science · Natural Language Processing",
  // researchFundedProjects: 2,
  accreditation: ["AICTE Approved Intake: 60 seats", "VTU Affiliated since 2022", "NAAC accreditation under preparation for first NBA cycle"],
  achievements: [
    {
      title: "Achievement Documents",
      items: [
        {
          label: "Merit Certificate - Aishwarya S. M.",
          href: "/Achievements/AIML/Aishwarya-S.-M.pdf"
        },
        {
          label: "Introduction to IoT Certificate - Ekata Shanbhag",
          href: "/Achievements/AIML/certificate-IOT-NPTLE.pdf"
        },
        {
          label: "Best Coordinator Award - Dr. Poornima Raikar",
          href: "/Achievements/AIML/Dr-Poornima-Raikar.pdf"
        },
        {
          label: "Robotrix 2024-25 Certificate - Sanjana Dhawale",
          href: "/Achievements/AIML/Robotix-Nitk.pdf"
        },
      ],
    },
  ],
  dashboard: [
    ["Faculty Members", "09"],
    ["Faculty with Ph.D.", "01"],
    ["Faculty pursuing Ph.D", "03"],
    ["Laboratories", "06"],
  ],
  academicVision:
    "To lead the way in the creation and application of cutting-edge Computer science and engineering (AIML) technologies, advancing the frontiers of knowledge, and empowering future generations to drive innovation and transformation on a global scale.",
  academicOverview: [
    {
      title: "Academic Strengths",
      text: "The institution is committed to academic excellence through qualified faculty, modern infrastructure, and outcome-based education. Strong industry collaborations and well-equipped laboratories support effective learning and skill development.",
    },
    {
      title: "Mission",
      text: [
        "To train students with a strong conceptual understanding using innovative pedagogies, empowering them to excel in the dynamic fields of Artificial Intelligence and Machine Learning.",
        "To imbibe professional, research, and entrepreneurial skills with a commitment to the nation's development at large.",
        "To strengthen the industry-institute interaction.",
        "To promote life-long learning with a sense of societal and ethical responsibilities.",
      ],
    },
    {
      title: "Beyond Syllabus",
      text: "The CSE (AI & ML) department enhances student learning through AISA student association activities, AI and Machine Learning laboratories, Generative AI and Data Science tool exposure, industry interactions, internships, research and innovation projects, technical workshops, hackathons, professional body activities, entrepreneurship initiatives, multidisciplinary project development, leadership opportunities, and placement-oriented skill training, fostering innovation, problem-solving, research aptitude, and industry readiness.",
    },
  ],
  curriculumSupport: [
    "Laboratory sessions provide hands-on experience in core and emerging technologies.",
    "Project-based learning enables students to apply theoretical knowledge to real-world problems.",
    "Internship opportunities help students gain industry exposure and practical experience.",
    "Regular workshops and seminars keep students updated with the latest technological advancements.",
    "Value-added courses and certification programs enhance technical skills beyond the university curriculum.",
    "Industry interactions bridge the gap between academic learning and industry requirements.",
    "Soft skills and employability training develop communication, leadership, and career readiness.",
    "Continuous mentoring and academic guidance support students' overall growth and success.",
  ],
  programmeOutcomes: [
    "Engineering knowledge: Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.",
    "Problem analysis: Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using the first principles of mathematics, natural sciences, and engineering sciences.",
    "Design/development of solutions: Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for public health and safety and cultural, societal, and environmental considerations.",
    "Conduct investigations of complex problems: Use research-based knowledge and research methods including design of experiments, analysis, interpretation of data, and synthesis of the information to provide valid conclusions.",
    "The engineer and society: Apply to reason informed by the contextual knowledge to assess societal, health, safety, legal and cultural issues and the consequent responsibilities relevant to the professional engineering practice.",
    "Environment and sustainability: Understand the impact of professional engineering solutions in societal and environmental contexts and demonstrate the knowledge of and need for sustainable development.",
    "Ethics: Apply ethical principles and commit to professional ethics and responsibilities and norms of the engineering practice.",
    "Individual and team work: Function effectively as an individual and as a member or leader in diverse teams and in multidisciplinary settings.",
    "Communication: Communicate effectively on complex engineering activities with the engineering community and with society at large, such as being able to comprehend and write effective reports and design documentation, make effective presentations and give and receive clear instructions.",
    "Project management and finance: Demonstrate knowledge and understanding of the engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.",
    "Recognize the need for lifelong learning and adapt to technological changes in mechanical engineering and allied fields.",
  ],
  pso: [
    "Develop abilities to model real-world problems using appropriate algorithms, computational theories, and programming languages in the area of AI and ML.",
    "Develop software applications and products in specialized areas of Artificial Intelligence and Machine Learning.",
  ],
  peo: [
    "Develop an ability to identify and analyze the requirements of Computer Science and Engineering in design and providing novel engineering solutions.",
    "Develop abilities to work in teams on multidisciplinary projects with effective communication skills, ethical qualities, and leadership roles.",
    "Develop abilities for successful Computer Science Engineering careers and achieve higher career goals.",
  ],
  // infrastructure: [
  //   ["Classrooms", "3"],
  //   ["Laboratories", "6"],
  //   ["Computing Facilities", "240"],
  //   ["Project Rooms", "1"],
  //   ["Department Library", "01"],
  //   ["Software Tools", "Code::Blocks, Anaconda, LaTeX, Oracle, Power BI"],
  //   ["Equipment Highlights", "Modern computing facilities with PCs configured to support academic, laboratory, and research activities."],
  // ],
  studentActivities: {
    clubs: [
      {
        name: "CISCO",
        category: "Professional Chapter",
        image: "/CSE_CLUB_LOGOS/CSE_CISCO.png",
        description:
          "CISCO activities expose students to networking, wireless technologies, security, cloud, collaboration, data center, virtualization, artificial intelligence, observability, software, and connected digital technologies.",
        reports: [
          { title: "CISCO", href: "/student-club/CSE/CISCO-2024-05-13.pdf" },
          // { title: "C-Force Report 2", href: "#" },
        ],
      },
      {
        name: "Infosys Springboard",
        category: "Professional Chapter",
        image: "/CSE_CLUB_LOGOS/CSE_CSI.png",
        description:
          "Student engagement, workshops, certifications, and technical activities through Infosys Springboard.",
        reports: [
          { title: "Infosys Springboard", href: "/student-club/CSE/INFOSYS SPRINGBOARD.pdf" },
          // { title: "C-Force Report 2", href: "#" },
        ],
      },
      {
        name: "ACM Student Chapter",
        category: "Professional Chapter",
        image: "/CSE_CLUB_LOGOS/CSE_ACM.png",
        description:
          "Student chapter Group id: 200565. The ACM Student Chapter at KLS VDIT provides a premier platform for students to explore modern computing, competitive programming, research, and global technical collaboration.",
        reports: [
          {
            title: "Technical Talk on DevOps Automation and CI/CD Pipeline",
            href: "/student-club/CSE/ACM/Technical-Talk-on-DevOps-Automation-and-CICD-Pipeline.pdf",
          },
          {
            title: "Technical Talk on Unlocking the Power of Data Science with Python",
            href: "/student-club/CSE/ACM/Technical-Talk-on-Unlocking-the-Power-of-Data-Science-With-Python.pdf",
          },
        ],
      },
      {
        name: "AISA",
        category: "Student Club",
        description:
          "AISA, the student association of the Computer Science and Engineering[AIML] department, is a dynamic platform fostering academic excellence and technical empowerment through alumni interaction, expert-led talks, hands-on workshops, mentorship sessions, hackathons, project exhibitions, conferences, and technical events.",
        reports: [
          { title: "Freshers Party", href: "/student-club/CSE[AI&ML]/Student association/Freshers-function-26th-Oct-2024-AIML-1.pdf" },
          // { title: "Navigating the IT Industry", href: "/student-club/CSE/CFORCE/Technical-talk-on-Navigating-the-IT-Industry-on-12-09-2024.pdf" },
        ],
      },
    ],
  },
  newsEvents: {
    reports: [
      { label: "Hands on Workshop Full Stack", href: "/EVENTS/CSE[AI&ML]/Hands-on-Workshop-FullStack.pdf" },
      { label: "Harnessing Java and Understanding AI", href: "/EVENTS/CSE[AI&ML]/Harnessing-Java-nad-Understanding-AI.pdf" },
      { label: "DevOps Automation and CI/CD Pipeline", href: "/EVENTS/CSE[AI&ML]/technical_talk_report_7thsem_AS_RP.pdf" },
    ],
  },
  featuredVideo: {
    title: "Department Video",
    sub: "A closer look at the CSE (AI & ML) department",
    embedUrl: "https://www.youtube.com/embed/ILUUPlRRj9M",
    iframeTitle: "CSE AI and ML department video",
  },

  facultyTable: [
    ["Dr. Poornima Raikar", "BE, M.Tech, Ph.D", "21 years"],
    ["Mr. Ravindra Patil", "BE, M.Tech", "14 years"],
    ["Mrs. Ekata Shanbhag", "BE, M.Tech", "3 years"],
    ["Mr. Bheerappa Sasanoor", "BE, M.Tech", "6 years"],
    ["Mr. Narasimha Dixit", "BE, M.Tech", "3 years"],
    ["Mr. Amarnath Swami", "BE, M.Tech", "1 year"],
    ["Mrs. Kanchan Khokale", "BE, M.Tech", "0.5 years"],
    ["Mrs. Jyoti Chitti", "BE, M.Tech", "6 years"],
  ],
  teachingStaff: [
    ["Dr. Poornima Raikar", "Assistant Professor"],
    ["Mr. Ravindra Patil", "Assistant Professor"],
    ["Mrs. Ekata Shanbhag", "Assistant Professor"],
    ["Mr. Bheerappa Sasanoor", "Assistant Professor"],
    ["Mr. Narasimha Dixit", "Assistant Professor"],
    ["Mr. Amarnath Swami", "Assistant Professor"],
    ["Mrs. Kanchan Khokale", "Assistant Professor"],
    ["Mrs. Jyoti Chitti", "Assistant Professor"],
    ["Miss. Laxmi Hattiholi", "Assistant Professor"],
  ],
  nonTeachingStaff: [
    ["Mr. Shankar Kuri", "Instructor"],
    ["Mrs. Radha Mavalange", "Asst. Instructor"],
    ["Mr. Nagesh Melinmani", "Peon"],
    ["Miss. Ujwala Honnoji", "Peon"],
    ["Mr. Hasan Kattimani", "Peon"],
  ],
};

const CSEAIML = () => <ProgrammeDetail programme={programme} />;

export default CSEAIML;
